import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    helpFAQ: [],
    helpContact: [],
    loading: false,
    status: "",
    error: "",
};

export const helpSlice = createSlice({
    name: "helpInfo",
    initialState,
    reducers: {},
});

export default helpSlice.reducer;
